import styled from 'styled-components'

export const Container = styled.div`
  padding-bottom: 64px;
`

export const Children = styled.div`
  margin: 0 auto;
  max-width: 1460px;
  padding: 0 50px;

  .slick-list {
    overflow: visible;
  }

  > .CarouselContainer {
    padding: 0;

    &:first-child {
      margin-top: 0;
    }
  }
`
